import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Footer from './Footer';

const MasterLayout = ({ children }) => (
  <div className="flex flex-col overflow-x-hidden bg-neutral-800 min-h-screen">
    <a href="#main-content" className="skip-link">
      Skip to main content
    </a>
    <Header />
    <main id="main-content" className="flex-1 outline-none min-h-0" tabIndex={-1}>
      {children}
    </main>
    <Footer />
  </div>
);

MasterLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MasterLayout;